import { delegate } from '@atomify/core';
import { elements } from '@source/utilities/dom';

import { IframeModal } from '../iframe-modal';

const MODAL_TRIGGER = '[js-hook-iframe-modal-trigger]';
const DELEGATE_EVENT = 'click';
const DELEGATE_TARGET = document;

interface ModalControllerOptions {
    ariaControls?: string;
    delegateEvent?: string;
    delegateTarget?: EventTarget;
}

export type iframeModalTriggerType = HTMLButtonElement | HTMLAnchorElement;

const iframeModalHolder = new Map<string, IframeModal>();

/**
 * Basic iframe modal controller that fetches the  url and places the content within an iframe.
 */
export const iframeModalController = (options?: ModalControllerOptions) => {
    delegate({
        selector: MODAL_TRIGGER,
        target: options?.delegateTarget || DELEGATE_TARGET,
        type: options?.delegateEvent || DELEGATE_EVENT,
        callback: event => {
            const target = (event as any).delegateTarget as iframeModalTriggerType;
            createIframeModal(target);
        },
    });
};

/**
 * Opens modal based upon data-iframe-url attribute
 * @param {HTMLButtonElement} target
 */
const createIframeModal = (target: iframeModalTriggerType) => {
    const { iframeUrl, iframeId, iframeTitle, iframeHeight, iframeWidth } = target.dataset;
    const isModalLoaded = iframeId && iframeModalHolder.has(iframeId);

    if (iframeUrl && iframeId && !isModalLoaded) {
        const modal = document.createElement('bpd-iframe-modal') as IframeModal;

        // Set modal src
        modal.src = iframeUrl;
        modal.modalTitle = iframeTitle || '';
        modal.setAttribute('id', iframeId);
        modal.minHeight = iframeHeight || '50vh';
        modal.minWidth = iframeWidth || '100%';

        // Append modal to the body and set the active state.
        elements.body.appendChild(modal);
        modal.active = true;

        iframeModalHolder.set(iframeId, modal);
    } else if (isModalLoaded && iframeId) {
        const modal = iframeModalHolder.get(iframeId);

        if (modal) {
            modal.active = true;
        }
    }
};
